module.exports = __webpack_public_path__ + "static/img/logo1.f815d96b.png";